import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import "./mainmenu.css";

const MainMenu = () => {
    const signedIn = Cookies.get('token') ? Cookies.get('token').length > 5 : false;

    return (
        <nav className="tl-main-nav">
            <ul className="tl-nav-list">
                <li className="tl-nav-item">
                    <Link className="tl-nav-link" to="/how-textlink-works">
                        How It Works
                    </Link>
                </li>
                <li className="tl-nav-item">
                    <Link className="tl-nav-link" to="/recommended-setup">
                        Recommended SIMs &amp; Devices
                    </Link>
                </li>
                <li className="tl-nav-item">
                    <Link className="tl-nav-link" to="/ghl">
                        GoHighLevel
                    </Link>
                </li>
                <li className="tl-nav-item">
                    <Link className="tl-nav-link" to="/pricing">
                        Pricing
                    </Link>
                </li>
                <li className="tl-nav-item">
                    <Link className="tl-nav-link" to="/affiliate-program">
                        Affiliate
                    </Link>
                </li>
                <li className="tl-nav-item">
                    <Link className="tl-nav-link" to="/contact">
                        Contact
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default MainMenu;
